<mat-table [dataSource]="binaries$">
  <ng-container matColumnDef="applianceGroup">
    <th mat-header-cell *matHeaderCellDef scope="col">{{ 'APPLIANCE_GROUPS' | translate }}</th>
    <td mat-cell *matCellDef="let binary">
      {{ applianceGroupsRefData[binary.applianceGroup].translatedName }}
    </td>
  </ng-container>
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef scope="col">{{ 'TYPE' | translate }}</th>
    <td mat-cell *matCellDef="let binary">{{ binary.type }}</td>
  </ng-container>
  <ng-container matColumnDef="creationDate">
    <th mat-header-cell *matHeaderCellDef scope="col">{{ 'CREATION_DATE' | translate }}</th>
    <td mat-cell *matCellDef="let binary">{{ binary.creationDate | date : 'dd/MM/yyyy HH:mm' }}</td>
  </ng-container>
  <ng-container matColumnDef="createdBy">
    <th mat-header-cell *matHeaderCellDef scope="col">{{ 'CREATED_BY' | translate }}</th>
    <td mat-cell *matCellDef="let binary">{{ binary.creator }}</td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef scope="col">{{ 'STATUS' | translate }}</th>
    <td mat-cell *matCellDef="let binary">{{ binary.type !== 'USB' ? (binary.status | translate) : '-' }}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef scope="col" class="column-buttons"></th>
    <td mat-cell *matCellDef="let binary" class="column-buttons">
      <a class="action" matTooltip="{{ 'DOWNLOAD' | translate }}" matTooltipClass="tooltip-main" [href]="binary.link">
        <i class="fas fa-download" aria-hidden="true"></i>
      </a>
      <a
        class="action"
        *ngIf="binary.type !== 'USB' && binary.status !== 'PUBLISHED' && binary.applianceGroup"
        matTooltip="{{ 'PUBLISH' | translate }}"
        matTooltipClass="tooltip-main"
        (click)="publishBinary$.next(binary)"
      >
        <i class="fas fa-check" aria-hidden="true"></i>
      </a>
      <a
        class="action"
        *ngIf="binary.status !== 'PUBLISHED'"
        matTooltip="{{ 'DELETE' | translate }}"
        matTooltipClass="tooltip-main"
        (click)="deleteBinary$.next(binary)"
      >
        <i class="fas fa-trash" aria-hidden="true"></i>
      </a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</mat-table>
